export default __webpack_public_path__ + "d415e1d2a4bcd594e4fb9302f1735e2c.png";